import type { ReactNode } from 'react'
import './SettingsGroup.css'

/** A grouped, inset list, design.md 8.3: an optional uppercase label, then rows in one
 *  rounded container with hairlines between. */
export function SettingsGroup({ label, children }: { label?: string; children: ReactNode }) {
  return (
    <div className="settings-group-wrap">
      {label && <div className="settings-group-label">{label}</div>}
      <div className="settings-group">{children}</div>
    </div>
  )
}

/** One row of a SettingsGroup: an optional leading icon, a title (and subtitle), and a
 *  control on the right. `labelFor` makes the title the label of that control. */
export function SettingsRow({
  leading,
  title,
  subtitle,
  trailing,
  labelFor,
}: {
  leading?: ReactNode
  title: ReactNode
  subtitle?: ReactNode
  trailing?: ReactNode
  labelFor?: string
}) {
  const text = (
    <>
      <div className="row-title">{title}</div>
      {subtitle && <div className="row-subtitle">{subtitle}</div>}
    </>
  )
  return (
    <div className="settings-row">
      <div className="row-left">
        {leading}
        {labelFor ? <label htmlFor={labelFor} className="row-text">{text}</label> : <div className="row-text">{text}</div>}
      </div>
      {trailing}
    </div>
  )
}
